// extracted by mini-css-extract-plugin
export var buttonContainer = "_7f-1";
export var fontSizeSelect = "_7f-3";
export var formatSelect = "_7f-2";
export var formats = "_7f-4";
export var hidden = "_7f-5";
export var icon = "_7f-6";
export var select = "_7f-0";